import MuiChip, { ChipProps } from '@material-ui/core/Chip';

import styled from 'styled-components';

export type DSChipProps = ChipProps;

export const DSChip = styled(MuiChip)`
    margin-left: ${({ theme }) => theme.spacing(1)}px;
`;
